'use client';

import { useEffect } from 'react';

export function useScrollBlock(isOff?: boolean, disableHook?: boolean) {
  useEffect(() => {
    if (disableHook) return;

    const body = document.body;

    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    const topOffset = window.pageYOffset;

    const bodyPaddingRight =
      Number.parseInt(
        window.getComputedStyle(body).getPropertyValue('padding-right')
      ) || 0;

    if (body.style.overflow === 'hidden') return;

    const block = () => {
      body.style.overflow = 'hidden';
      // body.style.position = 'fixed'; // is position fixed lazy loading in modals doesn't work. if position static there is scroll of body for ios
      body.style.paddingRight = `${bodyPaddingRight + scrollBarWidth}px`;

      body.style.position = 'fixed';
      body.style.top = `-${topOffset}px`;
      // body.style.bottom = '0';
      body.style.right = '0';
      body.style.left = '0';
    };

    const unblock = () => {
      body.style.removeProperty('overflow');
      body.style.paddingRight = '';

      body.style.position = 'static';
      body.style.top = 'auto';
      body.style.bottom = 'auto';
      body.style.right = 'auto';
      body.style.left = 'auto';
      window.scrollTo(0, topOffset);
    };

    if (isOff) {
      unblock();
    } else {
      block();
    }

    return () => {
      unblock();
    };
  }, [isOff, disableHook]);
}
